import { BETA_FEATURE_LLM_EVAL } from '@/lib/betaFeatures';
import {
  ORGANIZATION_PLAN_FREE,
  ORGANIZATION_USER_ROLES
} from '@shared/constants';
import { OrganizationUserRole } from '@shared/types';
import useBetaFeatureEnabled from '../useBetaFeatureEnabled';
import useCurrentOrganization from './useCurrentOrganization';

const useCurrentOrganizationUserRole = (): OrganizationUserRole => {
  const currentOrganization = useCurrentOrganization();
  const isLLMEvalEnabled = useBetaFeatureEnabled(BETA_FEATURE_LLM_EVAL);
  let defaultRole = ORGANIZATION_USER_ROLES.MEMBER;

  if (isLLMEvalEnabled) {
    defaultRole =
      currentOrganization?.paymentPlan === ORGANIZATION_PLAN_FREE
        ? ORGANIZATION_USER_ROLES.LLM_ONLY
        : ORGANIZATION_USER_ROLES.MEMBER;
  }

  return currentOrganization?.role || defaultRole;
};

export default useCurrentOrganizationUserRole;
